import $router from '@/router/index'
import storage from '@/store/storage'
import * as _util from '@/util/util'
const user = {
  state: {
    user: {},
  },
  mutations: {
    BIND_LOGIN(state, loginfo) {
      storage.setUser(loginfo.user);
      storage.setToken(loginfo.token);
      storage.setDict(loginfo.dicts);
      storage.setMenus(loginfo.menus);
      //state.menu = loginfo.menus;
    },
    BIND_LOGOUT: (state, token) => {
      let param = new FormData();
      param.append('token', token);
      _util.req_post(param, api.logout, function (
        _r
      ) {
        state.user = undefined;
        state.isLogin = false;
        storage.removeUser();
        storage.removeDict();
        storage.delToken();
        storage.removeMenus();
        storage.setLoginState(false);
        $router.push({ path: "/login" })
      });
    }
  },
  actions: {
    bindLogin({
      commit
    }, loginfo) {
      commit('BIND_LOGIN', loginfo)
    },
    bindLogout({
      commit
    }, token) {
      commit('BIND_LOGOUT', token)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js